module.exports = __webpack_public_path__ + "static/img/wujiang-text-cn.c307f73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wujiang-text-cn.png
// module id = Ydhu
// module chunks = 1